export const defaultAllDocs = Object.freeze({
    "Farther%20Records": null,
    "Alternative%20Investments": null,
    "Business%20Ownership": null,
    Education: null,
    "Employer%20Agreements": null,
    "Estate%20Planning": null,
    "Insurance%20Policies": null,
    Leases: null,
    Other: null,
    "Property%20Ownership": null,
    Statements: null,
    Taxes: null,
    Trusts: null,
    Vehicles: null,
});
export const s3BaseDirectories = [
    "Farther%20Records",
    "Alternative%20Investments",
    "Business%20Ownership",
    "Education",
    "Employer%20Agreements",
    "Estate%20Planning",
    "Insurance%20Policies",
    "Leases",
    "Other",
    "Property%20Ownership",
    "Statements",
    "Taxes",
    "Trusts",
    "Vehicles",
];
export const rootBaseDirectories = [
    "FartherRecords",
    "AlternativeInvestments",
    "BusinessOwnership",
    "Education",
    "EmployerAgreements",
    "EstatePlanning",
    "InsurancePolicies",
    "Leases",
    "Other",
    "PropertyOwnership",
    "Statements",
    "Taxes",
    "Trusts",
    "Vehicles",
];
//# sourceMappingURL=constants.js.map